import { AssetProperties } from './types/asset.type';

export type AliasSourceOption = {
  value: string;
  label: string;
  searchLabel: string;
  title: string;
};

export type AliasSourceGroupOption = {
  label: string;
  options: AliasSourceOption[];
};

export function buildAliasSourceOptions(
  assets: AssetProperties[],
  currentAssetId?: string,
) {
  const groupedAssets = new Map<string, AliasSourceGroupOption>();
  const usedSourceIdsByCompany = new Map<string, Set<string>>();

  assets.forEach((asset) => {
    const aliasId = String(asset.aliasId || '').trim();
    const sourceAssetId = asset.assetId;
    const companyName = asset.company?.name || 'No Company';

    // Group berdasarkan companyId, bukan nama
    const companyKey = asset.companyId ?? `no-company-${companyName}`;

    const usedSourceIds =
      usedSourceIdsByCompany.get(companyKey) ?? new Set<string>();

    if (
      aliasId ||
      asset.isRamus2 ||
      asset.assetId === currentAssetId ||
      usedSourceIds.has(sourceAssetId)
    ) {
      return;
    }

    usedSourceIds.add(sourceAssetId);
    usedSourceIdsByCompany.set(companyKey, usedSourceIds);

    let group = groupedAssets.get(companyKey);

    if (!group) {
      group = {
        label: companyName,
        options: [],
      };
      groupedAssets.set(companyKey, group);
    }

    group.options.push({
      value: sourceAssetId,
      label: asset.name,
      title: asset.name,
      searchLabel: [
        companyName,
        asset.name,
        asset.assetId,
        asset.aliasId,
        sourceAssetId,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase(),
    });
  });

  const res = Array.from(groupedAssets.values()).filter(
    (group) => group.options.length,
  );
  return res;
}
